(function () {
  'use strict';

  var nav = document.querySelector('[data-dyd-nav]');
  function updateNav() {
    if (!nav) return;
    nav.classList.toggle('is-scrolled', window.scrollY > 40);
  }
  updateNav();
  window.addEventListener('scroll', updateNav, { passive: true });

  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-scroll-target]');
    if (!link) return;
    var href = link.getAttribute('href');
    if (!href || href.charAt(0) !== '#') return;
    var target = document.querySelector(href);
    if (!target) return;
    event.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  document.querySelectorAll('[data-dyd-waitlist]').forEach(function (container) {
    var form = container.matches('form') ? container : container.querySelector('form');
    if (!form) return;
    var tagsInput = form.querySelector('[data-waitlist-tags]');
    var baseTags = tagsInput ? tagsInput.value : '';
    form.querySelectorAll('[data-preorder]').forEach(function (button) {
      button.addEventListener('click', function () {
        form.querySelectorAll('[data-preorder]').forEach(function (b) { b.classList.remove('is-selected'); });
        button.classList.add('is-selected');
        if (tagsInput) tagsInput.value = baseTags + ', preorder_' + button.dataset.preorder.toLowerCase();
      });
    });
  });

  document.querySelectorAll('[data-dyd-survey]').forEach(function (container) {
    var form = container.matches('form') ? container : container.querySelector('form');
    if (!form) return;
    var openButton = form.querySelector('[data-survey-open]');
    var panel = form.querySelector('[data-survey-panel]');
    var steps = Array.prototype.slice.call(form.querySelectorAll('[data-step]'));
    var progress = form.querySelector('[data-survey-progress]');
    var back = form.querySelector('[data-back]');
    var successBox = form.querySelector('[data-survey-success]');
    var errorBox = form.querySelector('[data-survey-error]');
    var submitButton = form.querySelector('[data-survey-submit]');
    var endpoint = form.getAttribute('data-survey-endpoint');
    var answers = {};
    var step = 0;
    var submitting = false;

    if (!panel || !steps.length) return;

    if (progress) {
      progress.innerHTML = '';
      for (var i = 0; i < steps.length; i += 1) {
        var bar = document.createElement('span');
        progress.appendChild(bar);
      }
    }

    function setAnswer(field, value, mode) {
      if (!field) return;
      if (mode === 'multi') {
        var arr = Array.isArray(answers[field]) ? answers[field].slice() : [];
        var index = arr.indexOf(value);
        if (index >= 0) arr.splice(index, 1);
        else arr.push(value);
        answers[field] = arr;
      } else {
        answers[field] = value;
      }
      refreshSelected();
      readInputs();
    }

    function refreshSelected() {
      form.querySelectorAll('[data-field]').forEach(function (button) {
        var field = button.dataset.field;
        var value = button.dataset.value;
        var current = answers[field];
        var selected = Array.isArray(current) ? current.indexOf(value) >= 0 : current === value;
        button.classList.toggle('is-selected', selected);
      });
    }

    function readInputs() {
      form.querySelectorAll('[data-field-text]').forEach(function (input) {
        answers[input.dataset.fieldText] = input.value;
      });
      form.querySelectorAll('[data-field-check]').forEach(function (input) {
        answers[input.dataset.fieldCheck] = !!input.checked;
      });
    }

    function hasAnswer(field) {
      var val = answers[field];
      return Array.isArray(val) ? val.length > 0 : !!val;
    }

    function canAdvance(currentStep) {
      readInputs();
      switch (currentStep) {
        case 0: return hasAnswer('use_case');
        case 1: return hasAnswer('current_electrolyte_usage');
        case 2: return hasAnswer('purchase_intent');
        case 3: return hasAnswer('buy_trigger');
        case 4: return hasAnswer('first_flavor_choice');
        case 5: return hasAnswer('other_flavors');
        case 6: return hasAnswer('price_range') && hasAnswer('first_pack_choice');
        default: return true;
      }
    }

    function showStep(nextStep) {
      step = Math.max(0, Math.min(nextStep, steps.length - 1));
      steps.forEach(function (el, idx) {
        el.hidden = idx !== step;
      });
      if (progress) {
        Array.prototype.slice.call(progress.children).forEach(function (bar, idx) {
          bar.classList.toggle('is-active', idx <= step);
        });
      }
      if (back) back.hidden = step === 0;
      readInputs();
    }

    function shake(el) {
      if (!el || !el.animate) return;
      el.animate([
        { transform: 'translateX(0)' },
        { transform: 'translateX(-5px)' },
        { transform: 'translateX(5px)' },
        { transform: 'translateX(0)' }
      ], { duration: 220 });
    }

    function showError(message) {
      if (!errorBox) return;
      errorBox.hidden = false;
      errorBox.textContent = message || 'Something broke. Your body has filed a complaint.';
    }

    function clearError() {
      if (!errorBox) return;
      errorBox.hidden = true;
      errorBox.textContent = '';
    }

    function validEmail(email) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(email || '').trim());
    }

    function getArray(field) {
      var value = answers[field];
      if (!value) return [];
      return Array.isArray(value) ? value : [value];
    }

    function buildPayload() {
      readInputs();
      return {
        email: String(answers.email || '').trim(),
        campaign: 'Batch_001',
        source: 'shopify_homepage',
        page_url: window.location.href,
        use_cases: getArray('use_case'),
        current_electrolyte_usage: answers.current_electrolyte_usage || null,
        current_brand: answers.current_brand_or_product || null,
        purchase_intent: answers.purchase_intent || null,
        buy_triggers: getArray('buy_trigger'),
        first_flavor_choice: answers.first_flavor_choice || null,
        other_flavors: getArray('other_flavors'),
        price_range: answers.price_range || null,
        pack_size: answers.first_pack_choice || null,
        tester_interest: getArray('message_type').indexOf('I want to test Batch_001') >= 0,
        final_feedback: answers.final_complaint_or_message || null,
        message_type: getArray('message_type'),
        marketing_consent: answers.marketing_consent !== false,
        company: form.querySelector('input[name="company"]') ? form.querySelector('input[name="company"]').value : ''
      };
    }

    async function submitSurvey() {
      if (submitting) return;
      clearError();
      readInputs();

      if (!hasAnswer('message_type')) {
        showError('Pick at least one final complaint/contact option. Bureaucracy requires a box checked.');
        shake(submitButton);
        return;
      }
      if (!validEmail(answers.email)) {
        showError('Enter a valid email so we can attach this complaint to a real human.');
        shake(submitButton);
        return;
      }
      if (!endpoint) {
        showError('Survey endpoint is missing. Tell Josh the backend wandered off.');
        return;
      }

      var payload = buildPayload();
      submitting = true;
      if (submitButton) {
        submitButton.disabled = true;
        submitButton.dataset.originalText = submitButton.textContent;
        submitButton.textContent = 'LOGGING COMPLAINT…';
      }

      try {
        var response = await fetch(endpoint, {
          method: 'POST',
          body: JSON.stringify(payload)
        });
        var result = await response.json().catch(function () { return {}; });
        if (!response.ok || !result.ok) {
          throw new Error(result.error || result.details || 'Survey submission failed');
        }
        if (panel) panel.hidden = true;
        if (openButton) openButton.hidden = true;
        if (successBox) successBox.hidden = false;
        form.classList.add('is-submitted');
        successBox && successBox.scrollIntoView({ behavior: 'smooth', block: 'center' });
      } catch (error) {
        showError(error.message || 'Submission failed. Hydration bureaucracy is having a moment.');
        if (submitButton) shake(submitButton);
      } finally {
        submitting = false;
        if (submitButton) {
          submitButton.disabled = false;
          submitButton.textContent = submitButton.dataset.originalText || 'HELP US NOT SCREW THIS UP →';
        }
      }
    }

    if (openButton) {
      openButton.addEventListener('click', function () {
        panel.hidden = false;
        openButton.hidden = true;
        showStep(0);
      });
    }

    form.addEventListener('click', function (event) {
      var option = event.target.closest('[data-field]');
      if (option && form.contains(option)) {
        var mode = option.dataset.multi === 'true' ? 'multi' : 'single';
        setAnswer(option.dataset.field, option.dataset.value, mode);
        if (option.dataset.auto === 'true') {
          window.setTimeout(function () { showStep(step + 1); }, 150);
        }
      }

      var next = event.target.closest('[data-next]');
      if (next && form.contains(next)) {
        clearError();
        if (canAdvance(step)) showStep(step + 1);
        else shake(next);
      }

      var backButton = event.target.closest('[data-back]');
      if (backButton && form.contains(backButton)) {
        clearError();
        showStep(step - 1);
      }
    });

    form.addEventListener('input', function () {
      readInputs();
      clearError();
    });

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (step !== steps.length - 1) return;
      submitSurvey();
    });

    showStep(0);
  });

  var exitPopup = document.querySelector('[data-exit-popup]');
  if (exitPopup) {
    var sessionKey = 'dyd_exit_intent_shown';
    var fired = false;
    function openExitPopup() {
      if (fired || sessionStorage.getItem(sessionKey)) return;
      fired = true;
      sessionStorage.setItem(sessionKey, '1');
      exitPopup.hidden = false;
    }
    function closeExitPopup() { exitPopup.hidden = true; }
    document.addEventListener('mouseout', function (event) {
      if (event.relatedTarget || event.toElement) return;
      if (event.clientY <= 0) openExitPopup();
    });
    window.setTimeout(openExitPopup, 45000);
    exitPopup.addEventListener('click', function (event) {
      if (event.target.closest('[data-exit-close]')) closeExitPopup();
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeExitPopup();
    });
  }
})();
